import {ApiJsonResult} from '../../utils/api/apijsonresult';
import {StringUtils} from '../../utils/string.utils';

export class Tracker {
    uid: string;
    emailAddress: string;
    childId: number;

    static populate(jsonObject: any): Tracker {
        const obj = new Tracker();
        obj.uid = jsonObject.uid;
        obj.emailAddress = jsonObject.emailAddress;
        obj.childId = jsonObject.childId;
        return obj;
    }

    static formPopulate(obj: Tracker, jsonObject: any): Tracker {
        if (obj == null) {
            obj = new Tracker();
        }
        obj.uid = jsonObject.uid;
        obj.emailAddress = jsonObject.emailAddress;
        return obj;
    }

    static apimapper(apijsonResult: ApiJsonResult): Tracker {
        let obj = null;
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            obj = Tracker.populate(jsonObject);
        }
        return obj;
    }

    static apimapperLst(apijsonResult: ApiJsonResult): Tracker [] {
        const lst: Tracker [] = [];
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            for (let i = 0; i < jsonObject.length; i++) {
                lst.push(Tracker.populate(jsonObject[i]));
            }
            return lst;
        }
    }
}
